import React from "react"
import SbEditable from "storyblok-react"
import { Page } from "../core"
 
const PagePost = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <Page blok={blok} />
    </SbEditable>
  )
}
 
export default PagePost